import { render } from "./PhoneLogin.vue?vue&type=template&id=554de038"
import script from "./PhoneLogin.vue?vue&type=script&lang=js"
export * from "./PhoneLogin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__